import { Injectable } from "@angular/core";
import { Query } from "@datorama/akita";
import { Observable } from "rxjs";
import { NerriSession } from "../../../api/auth/model/session";
import { UnauthorizedState, UnauthorizedStore } from "./unauthorized.store";

@Injectable()
export class UnauthorizedQuery extends Query<UnauthorizedState> {
    constructor(store: UnauthorizedStore) {
        super(store);
    }

    public selectSession(): Observable<NerriSession | null> {
        return this.select("session");
    }
}
